import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';

const FAQ = ({ settings }) => {
    const {
        title = "Frequently Asked Questions",
        faqs = [],
        bg,
        titleColor,
        questionColor,
        answerColor
    } = settings;

    const [openIndex, setOpenIndex] = useState(null);

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div
            className="w-full py-16 px-4"
            style={{
                backgroundColor: bg || 'var(--store-bg)',
                color: titleColor || 'var(--store-text)'
            }}
        >
            <div className="max-w-3xl mx-auto">
                {title && (
                    <h2
                        className="text-3xl font-bold text-center mb-12"
                        style={{ color: titleColor || 'inherit' }}
                    >
                        {title}
                    </h2>
                )}

                <div className="space-y-0 border-t border-[var(--store-border)]">
                    {faqs.map((faq, index) => (
                        <div
                            key={index}
                            className="border-b border-[var(--store-border)] overflow-hidden"
                        >
                            <button
                                onClick={() => toggleFAQ(index)}
                                className="w-full flex items-center justify-between py-6 text-left focus:outline-none group"
                            >
                                <span
                                    className="text-lg font-medium pr-8 group-hover:opacity-80 transition-opacity"
                                    style={{ color: questionColor || 'inherit' }}
                                >
                                    {faq.question}
                                </span>
                                {openIndex === index ? (
                                    <Minus
                                        className="flex-shrink-0"
                                        size={20}
                                        style={{ color: questionColor || 'var(--store-muted)' }}
                                    />
                                ) : (
                                    <Plus
                                        className="flex-shrink-0"
                                        size={20}
                                        style={{ color: questionColor || 'var(--store-muted)' }}
                                    />
                                )}
                            </button>

                            <div
                                className={`transition-all duration-500 ease-in-out overflow-hidden ${openIndex === index ? 'max-h-96 opacity-100 mb-6' : 'max-h-0 opacity-0'
                                    }`}
                            >
                                <div
                                    className="leading-relaxed text-lg"
                                    style={{ color: answerColor || 'var(--store-muted)' }}
                                >
                                    {faq.answer}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default FAQ;
